export default {"src":"/_next/static/media/schoonspringen.a4e64311.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};